import { ONBOARDING_BASE_PATHS, ROUTES } from "../constants";

export function getCurrentOnboardingBasePath() {
  const segment = window.location.pathname.split("/")?.[1]?.toLowerCase();
  if (segment === ONBOARDING_BASE_PATHS.loan) {
    return ONBOARDING_BASE_PATHS.loan;
  }
  return ONBOARDING_BASE_PATHS.pi;
}

export function onboardingPath(route) {
  return `/${getCurrentOnboardingBasePath()}/${route}`;
}

export const handleIdentificationStepChange = (
  step,
  history,
  otherParams = []
) => {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.set("step", step);
  if (otherParams.length) {
    otherParams.forEach((item) => {
      return searchParams.set(item?.[0], item?.[1]);
    });
  }
  history.push({
    pathname: window.location.pathname,
    search: searchParams.toString(),
  });
};

export const decodeJwt = (token) => {
  if (!token) return;
  const payload = token.split(".")?.[1];
  return JSON.parse(base64UrlDecode(payload));
};

export const getClientTypeIdFromOnboardingToken = () => {
  const onboardingToken = sessionStorage.getItem("onboardingToken");
  const payload = decodeJwt(onboardingToken);
  return Number(payload?.ClientTypeId) || null;
};

function base64UrlDecode(str) {
  const base64 = str.replace(/-/g, "+").replace(/_/g, "/");
  const padded = base64.padEnd(
    base64.length + ((4 - (base64.length % 4)) % 4),
    "="
  );

  const binary = Uint8Array.from(atob(padded), (c) => c.charCodeAt(0));
  return new TextDecoder().decode(binary);
}

export const getErrorMessage = (err) => {
  return err?.response?.data?.Message || err?.message;
};

export const getErrorCode = (err) => err?.response?.data?.Code;

export const redirectToPiOnboardingIdentification = () => {
  sessionStorage.removeItem("onboardingToken");
  const currentParams = new URLSearchParams(window.location.search);
  const onboardingType = currentParams.get("onboarding-type");
  const nextParams = new URLSearchParams();

  if (onboardingType) {
    nextParams.set("onboarding-type", onboardingType);
  }

  const search = nextParams.toString();
  window.location.href = `${onboardingPath(ROUTES.identification)}${
    search ? `?${search}` : ""
  }`;
};
